import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import momentz from 'moment-timezone';
import { Link } from 'react-router-dom';
import { Button } from '@material-ui/core';
import { is_weekend } from '../../components/Modals/UOAModal/getDate';
import { setAppStateAction } from '../../actions/appStateAction';
import { refreshDataAndExpirationsFunc } from '../../Shared';
import styles from './OptionsBoardStyles';
import Calender from '../../components/Calender';
import { setOptionChainAction } from '../../actions/optionChainAction';

const StockTicker = ({ keyPress }) => {
	const { appReducer, optionChainReducer } = useSelector((state) => state);
	const dispatch = useDispatch();
	const { ticker, accessLevel } = appReducer;
	const { localTicker, selectedDate } = optionChainReducer;

	const setAppState = (payload) => dispatch(setAppStateAction(payload));
	const setOptionChainState = (payload) =>
		dispatch(setOptionChainAction(payload));

	const changeTicker = async (event) => {
		const newTicker = event.target.value.toUpperCase();
		dispatch(setAppStateAction({ ticker: newTicker, tickerChanged: true }));
	};
	const goTicker = async () => {
		dispatch(
			setAppStateAction({
				targetPrice: 0,
			})
		);
		let date = momentz.tz(new Date(), 'America/New_York').format('YYYY-MM-DD');
		const newDate = accessLevel === 'fullaccess' ? is_weekend(date) : date;
		setOptionChainState({
			isDateSelected: true,
			strikeValue: 'all',
			nearValue: undefined,
			modalDate: newDate,
			selectedDate: newDate,
			localTicker: ticker,
		});
		localStorage.setItem('StrikeValue', 'all');
		localStorage.setItem('Date', newDate);
		await refreshDataAndExpirationsFunc(
			ticker,
			newDate,
			appReducer,
			setAppState
		);
		window.scroll(0, 0);
	};

	const dateChangeHandler = async (selectedDate) => {
		await refreshDataAndExpirationsFunc(
			ticker,
			selectedDate,
			appReducer,
			setAppState
		);
		setOptionChainState({
			selectedDate: selectedDate,
			isDateSelected: true,
			modalDate: selectedDate,
		});
	};

	return (
		<div>
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center',
				}}
			>
				<div style={styles.tickerContainer}>
					<input
						name='ticker'
						style={styles.tickerInput}
						value={ticker}
						placeholder='Stock Ticker'
						onChange={(event) => changeTicker(event)}
						onKeyDown={(event) => keyPress(event)}
					/>
					<Link
						to={`/optionschain/${ticker}`}
						style={{ textDecoration: 'none' }}
					>
						<Button
							id='btnGO'
							variant='contained'
							style={styles.goButton}
							onClick={goTicker}
						>
							Go
						</Button>
					</Link>
				</div>
			</div>
			<div style={styles.calenderOB}>
				<Calender
					accessLevel={accessLevel}
					value={selectedDate}
					disabled={localTicker === '' ? true : false}
					getDate={(e) => dateChangeHandler(e)}
				/>
			</div>
		</div>
	);
};

export default StockTicker;



// WEBPACK FOOTER //
// ./src/Pages/OptionsBoard/StockTicker.jsx